import { render, staticRenderFns } from "./process-table.vue?vue&type=template&id=6d69cc6c"
import script from "./process-table.vue?vue&type=script&lang=js"
export * from "./process-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports